export const capitalize = text => `${text[0].toUpperCase()}${text.slice(1)}`;

export const removeTags = text => text.replace(/(<([^>]+)>)/gi, '');
